export function isPoppySeason(d = new Date()) {
  const m = d.getMonth() + 1;
  const day = d.getDate();
  return (m === 10 && day >= 26) || (m === 11 && day <= 15);
}

export function Poppy({ size = 28, className = "" }) {
  if (!isPoppySeason()) return null;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      className={`inline-block shrink-0 ${className}`}
      role="img"
      aria-label="Remembrance poppy"
      data-testid="remembrance-poppy"
    >
      <title>Lest we forget</title>
      <path d="M33 36 C40 44 46 50 50 60" stroke="#1f6b2e" strokeWidth="3" fill="none" strokeLinecap="round" />
      <path d="M40 44 C48 38 58 40 62 46 C55 50 46 50 40 44 Z" fill="#2e8b3d" />
      <path d="M40 44 C48 43 55 44 62 46" stroke="#1f6b2e" strokeWidth="1" fill="none" />
      <ellipse cx="21" cy="20" rx="17" ry="15" fill="#b80f2a" transform="rotate(-20 21 20)" />
      <ellipse cx="42" cy="19" rx="17" ry="15" fill="#c8102e" transform="rotate(18 42 19)" />
      <ellipse cx="19" cy="38" rx="15" ry="13" fill="#d4142f" transform="rotate(25 19 38)" />
      <ellipse cx="41" cy="39" rx="15" ry="13" fill="#e01b35" transform="rotate(-22 41 39)" />
      <path d="M12 16 C17 13 22 13 26 16 M38 13 C43 12 48 14 51 18 M11 40 C15 44 19 45 23 44 M38 46 C43 46 47 43 49 39" stroke="#ff5a6e" strokeOpacity="0.45" strokeWidth="1.2" fill="none" strokeLinecap="round" />
      <circle cx="31" cy="29" r="8.5" fill="#111" />
      <circle cx="31" cy="29" r="4" fill="#2a2a2a" />
      <circle cx="29.5" cy="27.5" r="1.4" fill="#555" />
    </svg>
  );
}
